module.exports = __webpack_public_path__ + "static/Icon4-5142b36a1b0ba75704b900df3486219b.png";